module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-static-info-right-image', [_c('h2', {
    staticClass: "static-info--name",
    attrs: {
      "slot": "static-name"
    },
    slot: "static-name"
  }, [_vm._v("Bundles")])]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-divider')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0106ebe8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vouchers/bundles/bundles.vue
// module id = 923
// module chunks = 0